import { AppDefinition } from '../../types/apps';

export const EntityGraphAppDefinition: AppDefinition = {
  appId: 'entity-graph',
  name: 'Entity Graph',
  version: '1.0.0',
  description: 'Extract and link real-world entities from your data sources.',
  longDescription: `Entity Graph scans your Gmail and other connected data sources to discover real-world entities — properties, companies, vehicles, deals, insurance policies, subscriptions, and more. Each entity is extracted with an intelligent schema, proposed linkages to other entities, and source provenance. You review, modify, and approve entities to build your personal knowledge graph.`,

  icon: {
    type: 'phosphor',
    phosphorIcon: 'TreeStructure',
    phosphorWeight: 'duotone',
    color: '#06b6d4',
  },

  creator: {
    name: 'River',
    verified: true,
  },

  categories: ['Productivity', 'Personal'],
  tags: ['entities', 'extraction', 'graph', 'knowledge', 'linking'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),

  entityTypes: [
    'ExtractionRun', 'Property', 'Company', 'Vehicle', 'Deal',
    'LegalEntity', 'LegalFiling', 'SecurityInstrument',
    'Transaction', 'Insurance', 'Subscription',
  ],
  searchableSkeletonFields: {
    Property: ['address', 'notes'],
    Company: ['legalName', 'tradeName', 'domain', 'industry', 'description'],
    Vehicle: ['make', 'model', 'vin', 'licensePlate'],
    Deal: ['stage', 'counterparty', 'notes'],
    LegalEntity: ['entityName', 'type', 'state'],
    LegalFiling: ['filingType', 'jurisdiction', 'referenceNumber'],
    SecurityInstrument: ['instrumentType', 'notes'],
    Transaction: ['merchant', 'category', 'notes'],
    Insurance: ['provider', 'policyNumber', 'policyType'],
    Subscription: ['service', 'plan'],
  },

  component: 'entity-graph',
  requiresEntity: false,
  requiresProps: false,
  experimental: true,
  hidden: true,

  actions: {
    startExtraction: {
      name: 'Start Extraction',
      description: 'Start a new entity extraction run',
      parameters: {
        sources: { type: 'string', required: false },
        schemas: { type: 'string', required: false },
      },
    },
  },
};
